import DocFileSvg from 'src/assets/images/doc.svg';
import styled from 'styled-components';

export const DocFileIcon = styled(DocFileSvg)`
  height: 4.375rem;
`;
